import React, { Component } from 'react'

import { Card } from '../../components/card'
import { Vehicle } from '../../core/types'

export interface Props {
  vehicle: Vehicle
}

export default class VehicleDetailsInfo extends Component<Props> {
  static displayName = 'VehicleHeader'

  render() {
    const { year, make, model, selected_trim, financeable } = this.props.vehicle

    return (
      <Card gridClass="vehicle-details-info" title="DETAILS">
        <div className="vehicle-details-info__row">
          {year} {make} {model}
        </div>
        <div className="vehicle-details-info__row">
          {selected_trim && selected_trim.series ? (
            <div>{selected_trim.series}</div>
          ) : (
            <div>No Trim</div>
          )}
        </div>
        <div className="vehicle-details-info__row">
          {financeable ? <div>Financeable</div> : <div>Not Financeable</div>}
        </div>
      </Card>
    )
  }
}
